import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3" }
const _hoisted_2 = {
  key: 0,
  class: "grid gap-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_new_select = _resolveComponent("new-select")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Смена статуса",
    loading: _ctx.isLoading,
    "confirm-disabled": _ctx.isLoading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitSubmit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.ftlType === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_file_reader, {
                accept: "all",
                placeholder: "Фото пломбы",
                value: _ctx.payload.stamp,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payload.stamp) = $event)),
                disabled: _ctx.isLoading,
                "is-invalid": _ctx.state_form$.stamp.$error,
                "validation-errors": _ctx.state_form$.stamp.$errors
              }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
              _createVNode(_component_file_reader, {
                accept: "application/pdf",
                placeholder: "Инвойс",
                value: _ctx.payload.invoice,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payload.invoice) = $event)),
                disabled: _ctx.isLoading,
                "is-invalid": _ctx.state_form$.invoice.$error,
                "validation-errors": _ctx.state_form$.invoice.$errors
              }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
              _createVNode(_component_file_reader, {
                accept: "application/pdf",
                placeholder: "Пакинг лист",
                value: _ctx.payload.packing_list,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payload.packing_list) = $event)),
                disabled: _ctx.isLoading,
                "is-invalid": _ctx.state_form$.packing_list.$error,
                "validation-errors": _ctx.state_form$.packing_list.$errors
              }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
              _createVNode(_component_file_reader, {
                accept: "application/pdf",
                placeholder: "Сертификат происхождения",
                value: _ctx.payload.certificate_of_origin,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payload.certificate_of_origin) = $event)),
                disabled: _ctx.isLoading,
                "is-invalid": _ctx.state_form$.certificate_of_origin.$error,
                "validation-errors": _ctx.state_form$.certificate_of_origin.$errors
              }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
              _createVNode(_component_file_reader, {
                accept: "application/pdf",
                placeholder: "Сертификат безопасности",
                value: _ctx.payload.certificate_of_safety,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.payload.certificate_of_safety) = $event)),
                disabled: _ctx.isLoading
              }, null, 8, ["value", "disabled"]),
              _createVNode(_component_new_select, {
                "can-deselect": "",
                class: "my-2",
                placeholder: "Выберите причину",
                loading: _ctx.data_state.comments.is_loading,
                failed: _ctx.data_state.comments.is_failed,
                disabled: _ctx.isLoading || _ctx.data_state.comments.is_loading,
                "search-without-refresh": "",
                options: _ctx.data_state.comments.list,
                value: _ctx.payload.delayCommentId,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payload.delayCommentId) = $event)),
                "is-invalid": _ctx.state_form$.delayCommentId.$error,
                "validation-errors": _ctx.state_form$.delayCommentId.$errors,
                onRefresh: _ctx.loadComments
              }, null, 8, ["loading", "failed", "disabled", "options", "value", "is-invalid", "validation-errors", "onRefresh"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["loading", "confirm-disabled", "onCancel", "onConfirm"]))
}